import axios from "@/libs/api.request";

export const login = ({ userId, password }) => {
  const data = {
    userId,
    password
  }
  return axios.request({
    url: 'security/validateUser',
    params: data,
    method: 'get'
  })
}

export const logout = () => {
  return axios.request({
    url: 'security/logout',
    method: 'get'
  })
}


export const fetchUserInfo = () => {
  return axios.request({
    url: 'security/getUserAccess',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js